import { i18n } from '@/plugins/vue-i18n';
import quillOptions from '@/components/texteditor/config/options';
import quillConfig from '@/components/texteditor/config/advanced';
import DailymotionEmbed from 'sites/components/texteditor/advanced/blots/dailymotionEmbed';
import DailymotionButton from 'sites/components/texteditor/advanced/buttons/DailymotionButton';
import { Quill } from '@/plugins/quilljs';
import { $t } from 'bcube-cms/src/utils';

Quill.register(DailymotionEmbed);

// Paleta de colores para el botón para pintar el fondo del texto en quill
const COLORS = [
  '#F8E71C', '#FFFBC6', '#ADDDFF', '#D4EDFF', '#D8D8D8', '#F1F1F1', '#C0FF00',
  '#FFD9A1', '#92BDEE', '#BCD0DE', '#75D2D5', '#BCEDEF', '#43FDFF', '#EBFFAD',
];

// Quill (Body editor) toolbar options
quillOptions.advanced.modules.toolbar.container = [
  [{ header: [2, 3, false] }],
  ['bold', 'italic', 'strike', 'link', 'advanced-link', { background: COLORS }, 'anchor-link'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['clean'],
  ['undo', 'redo'],
  ['search-replace'],
  ['fullscreen'],
];

//
quillOptions.basic.modules.toolbar.container = [
  ['bold', 'italic', 'strike', 'link', { background: COLORS }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['clean'],
];

quillConfig.sidebar = {
  'ql-blockquote': quillConfig.sidebar['ql-blockquote'],
  'ql-image': quillConfig.sidebar['ql-image'],
  'ql-audio': quillConfig.sidebar['ql-audio'],
  'ql-video': quillConfig.sidebar['ql-video'],
  'ql-youtube': quillConfig.sidebar['ql-youtube'],
  'ql-dailymotion': {
    icon: 'fab fa-dailymotion',
    title: $t('message.editor.button.dailymotion'),
    active: true,
    disabled: false,
    component: DailymotionButton,
  },
  'ql-tweet': quillConfig.sidebar['ql-tweet'],
  'ql-facebook': quillConfig.sidebar['ql-facebook'],
  'ql-instagram': quillConfig.sidebar['ql-instagram'],
  'ql-code': {
    ...quillConfig.sidebar['ql-code'],
    title: i18n.t('message.editor.button.code'),
  },
  'ql-html': {
    ...quillConfig.sidebar['ql-html'],
    title: i18n.t('message.editor.button.html'),
  },
};
